import React, { PropTypes } from 'react'
import ZoomInImg from 'images/icon-zoom-in.png'
import className from 'classnames'

const AccessoriesGrid = ({ accessories, colorFilters, accessoryType, onSelectAccessory, reshaft, restoration, closeModal, onZoomAccessory, closeZoomModal }) => (
  <div className="accessories-grid">
    {accessories.options
      .filter(accessory => ( !(colorFilters.length > 0) || !!(colorFilters.filter(colorFilter => colorFilter.label === accessory.color).length > 0)))
      .map(accessory => (
        <div
          className={"grid-item " + ((!!accessories.selected && accessory.id === accessories.selected.id) ? 'selected' : '')}
          key={accessory.id}
          onClick={() => {onSelectAccessory(accessoryType, accessory.id); if(!!closeModal) {closeModal();} }}
        >
          <div className={className("img-container", { "no-selection": accessory.id === 0})}>
            {accessory.imageUrl && 
              <img src={accessory.imageUrl} alt={accessory.label}/>
            }
          </div>
          <div className={className({"accessory-label" : accessory.id})}>{accessory.label}</div>
          {accessory.price >= 0 &&
          <div className="accessory-price">${accessory.price}</div>
          }
          {accessory.imageUrl && 
          <div className="accessory-zoom">
            <img alt={`Zoom`} src={ZoomInImg} className={'zoom-in-img'} onClick={(event) => onZoomAccessory(event, accessory.imageUrl, accessory.id, accessory.label, accessoryType, accessory.price)} />
          </div>
          }
        </div>
      ))
    }
  </div>
)
  

AccessoriesGrid.defaultProps = {
}

AccessoriesGrid.propTypes = {
  accessoryType: PropTypes.string.isRequired,
  colorFilters: PropTypes.arrayOf(PropTypes.object),
  accessories: PropTypes.object.isRequired,
  onSelectAccessory: PropTypes.func.isRequired,
  reshaft: PropTypes.object,
  restoration: PropTypes.object,
}

export default AccessoriesGrid